import React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { IconButton, styled as materialStyled } from '@mui/material';
import { disabledColor } from 'components/views/default';

const IconBox = materialStyled(IconButton)({
    margin: '5px 5px',
    padding: '1vh',
    backgroundColor: 'rgba(39, 155, 230, 0.4)',
    borderRadius: '30%',
    border: 'thin solid gray',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

const Frame = styled.div<{ color?: string; flip: boolean; animation?: string; frameHeight?: string; frameWidth?: string; }>(props => ({
    height: props.frameHeight ?? '4vh',
    width: props.frameWidth ?? '4vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transform: props.flip ? 'scaleX(-1)' : 'none',
    animation: props.animation,
    color: props.color,
}));

const FontIcon = styled(FontAwesomeIcon)({
    height: '100%',
    width: '100%',
});

export interface CockpitButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon: IconDefinition;
    color?: string;
    size?: SizeProp;
    flip?: boolean;
    animation?: string;
    frameHeight?: string;
    frameWidth?: string;
}

export const CockpitButton = (props: CockpitButtonProps) => {
    const { icon, color, size, disabled, flip = false, animation, onClick, frameWidth, frameHeight } = props;

    const isDisabled = disabled ?? false;
    const iconColor = color ?? (isDisabled ? disabledColor : undefined);

    return (
        <IconBox onClick={onClick} disabled={isDisabled}>
            <Frame flip={flip} animation={animation} color={iconColor} frameWidth={frameWidth} frameHeight={frameHeight}>
                <FontIcon icon={icon} size={size ?? '4x'} color='inherit' ></FontIcon>
            </Frame>
        </IconBox>
    );
};
